import { useSortable } from "@dnd-kit/sortable";
import React from "react";
import { CSS } from "@dnd-kit/utilities";
import { Grid, Typography, IconButton } from "@mui/material";
import { Delete, DragIndicator } from "@mui/icons-material";
import { Base } from "../../base";
import getAnswerTypeName from "../../../helpers/getAnswerTypeName";
import Question, { AnswerTypes } from "../../../types/questionVM";

interface Props {
  children: React.ReactNode;
  question: Question;
  removeQuestion: () => void;
}

const SortItem: React.FC<Props> = (props) => {
  const { children, question, removeQuestion } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef,
  } = useSortable({
    id: question.order,
    data: question,
    animateLayoutChanges: () => false,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition: transition,
        paddingBottom: 25,
        width: "100%",
      }}
    >
      <Grid
        key={question.order}
        size={{ xs: 12 }}
        border="1px solid black"
        borderRadius={"25px"}
        padding={3}
        gap={2}
      >
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid>
            <IconButton
              {...attributes}
              {...listeners}
              ref={setActivatorNodeRef}
            >
              <DragIndicator />
            </IconButton>
          </Grid>
          <Grid>
            <Typography>
              {getAnswerTypeName(question.answerType.id!)}
            </Typography>{" "}
          </Grid>
          <Grid>
            {question.answerType.id !== AnswerTypes.Status &&
              question.answerType.id !== AnswerTypes.Title && (
                <Base.IconButton
                  onClick={removeQuestion}
                  label=""
                  icon={<Delete />}
                />
              )}
          </Grid>
        </Grid>
        {children}
      </Grid>
    </div>
  );
};

export default SortItem;
